import { Table, TableBody, TableContainer, TableCell, TableHead, TableRow } from '@mui/material'
import { UsageLogInfo } from 'api/usageLog'
import { format } from 'date-fns'

type Props = {
  rows: UsageLogInfo[]
}

function UsageLogTable(props: Props) {
  const { rows } = props

  const columns = [
    '日時',
    'ビジネスID',
    '操作',
    '文書タイプ',
    '文書名',
    'ステータス',
    'メッセージ',
    '利用者名',
  ]

  const tableColumns = columns.map((column) => {
    return (
      <TableCell key={column}>
        <p>{column}</p>
      </TableCell>
    )
  })

  const actionConvert = {
    LOGIN: 'ログイン',
    LOGOUT: 'ログアウト',
    NEW: '新規登録',
    UPDATE: '結果編集',
    EXPORT: '結果出力',
  }

  const statusConvert = {
    OK: '正常',
    NG: '異常',
    UNKNOWN: '不明',
  }

  const tableRows = rows.map((row, idx) => {
    const date = format(new Date(row.timestamp), 'yyyy/MM/dd HH:mm:ss')
    return (
      /* eslint-disable-next-line */
      <TableRow key={idx}>
        <TableCell>{date}</TableCell>
        <TableCell>{row.business_id}</TableCell>
        <TableCell>{actionConvert[row.action]}</TableCell>
        <TableCell>{row.document_type}</TableCell>
        <TableCell>{row.document_name}</TableCell>
        <TableCell>{statusConvert[row.status]}</TableCell>
        <TableCell>{row.message}</TableCell>
        <TableCell>{row.user_name}</TableCell>
      </TableRow>
    )
  })

  return (
    <TableContainer>
      <Table
        stickyHeader
        sx={{
          whiteSpace: 'nowrap',
        }}
        aria-labelledby="tableTitle"
        size={'medium'}
        aria-label="enhanced table"
      >
        <TableHead data-testid="usage-log-table-head">
          <TableRow>{tableColumns}</TableRow>
        </TableHead>
        <TableBody data-testid="usage-log-table-body">{tableRows}</TableBody>
      </Table>
    </TableContainer>
  )
}

export default UsageLogTable
